var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.465 15.8606C9.21 15.9506 8.79 15.9506 8.535 15.8606C6.36 15.1181 1.5 12.0206 1.5 6.77063C1.5 4.45312 3.3675 2.57812 5.67 2.57812C7.035 2.57812 8.2425 3.23813 9 4.25813C9.7575 3.23813 10.9725 2.57812 12.33 2.57812C14.6325 2.57813 16.5 4.45312 16.5 6.77063C16.5 12.0206 11.64 15.1181 9.465 15.8606Z",
    stroke: "#00BC92",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartIcon);
export default __webpack_public_path__ + "static/media/heartIcon.5787bbaacb6403d9e270b043b1386639.svg";
export { ForwardRef as ReactComponent };